module.exports = __webpack_public_path__ + "img/04233310.765e6589.png";